<template>
  <div class="traffic-limit-container"
       v-if="!hasPermission">
    <div class="traffic-limit-container-inner"
         v-if="!hasPermission">
      <img src="../../../../static/img/noAauthority.png"
           alt
           class="limit-img">
      <span class="limit-text">{{$t('bwTraffic.noPermission')}}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Permission',
  data () {
    return {
      tip: this.$t('speechcraft.limit'),
      hasPermission: true,
    };
  },
  created () {
    this.$api.getMenuPermission().then((res) => {
      if (res.errno === 10000 && res.errmsg === 'OK') {
        this.hasPermission = res.data.menuPermission.monitor;
        this.$emit('permissionHandle', this.hasPermission);
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.traffic-limit-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  // align-items: center;
    padding-top:80px;
  .traffic-limit-container-inner {
    display: inline-flex;
    align-items: center;
    flex-direction: column;
  }
  img {
    width: 224px;
  }
  .limit-text {
    margin: 40px 0 10px;
    text-align: center;
    font-size: 24px;
    font-family: 500;
    padding: 0 0 0 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bandwidthTraffic/opt/Permission.vue